import * as React from 'react';
import { DateInput, DateInputProps } from '../inputs/DateInput';
import { FormField } from './FormField';

type DateInputFieldProps = DateInputProps & {
    label:string,
    infoMessage?:string,
    validator:(value:Date|null) => { valid:true } | {valid:false, errorMessage:string}
};

export function DateInputField(props:DateInputFieldProps)
{
    const validatorResult = props.validator(props.value);

    return (
        <FormField 
            label={props.label} 
            inputComponent={
                <div>
                    <DateInput {...props} inErrorState={!validatorResult.valid} />
                </div>
            }
            inErrorState={!validatorResult.valid}
            message={validatorResult.valid===true ? props.infoMessage || '' : validatorResult.errorMessage}
        />
    )
}